export default __webpack_public_path__ + "5f889b29fbfbe8441b13ebba67f2b743.svg";